import calculateDuration from "utils/helpers/calculateDuration/calculateDuration";

export default calculateDuration;
